import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button, Box, Dialog, DialogTitle, Typography, DialogContent, DialogActions, } from '@mui/material';
import { Error } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { confirmDialogSGStyles } from './confirmDialogSGStyles';
/**
 * Delete confirm dialog
 * @param props ConfirmDialogSG's props
 * @returns JSX Element
 */
export const ConfirmDialogSG = function (props) {
    const { deleteDialogOpen, handleDeleteClickClose, handleDeleteConfirmClick } = props;
    // Get translation function
    const { /** Translation function */ t } = useTranslation();
    return (_jsxs(Dialog, Object.assign({ sx: {
            '& .MuiDialog-paper': {
                background: 'linear-gradient(0deg, rgba(0, 108, 73, 0.11), rgba(0, 108, 73, 0.11)), #FBFDF9',
                borderRadius: '1.75rem',
                textAlign: 'center',
            },
        }, open: deleteDialogOpen, onClose: handleDeleteClickClose }, { children: [_jsxs(DialogTitle, Object.assign({ sx: {
                    padding: '1.5rem 1.5rem 1rem',
                } }, { children: [_jsx(Box, Object.assign({ sx: {
                            width: '100%',
                            padding: '0 0 1rem',
                            lineHeight: '0',
                        } }, { children: _jsx(Error, { sx: { color: 'blackDark.main' } }) })), _jsx(Typography, Object.assign({ variant: 'text22', sx: {
                            color: 'greyBlack',
                        } }, { children: t('Confirm to Delete') }))] })), _jsx(DialogContent, Object.assign({ sx: {
                    padding: '0 1.5rem 1.5rem',
                } }, { children: _jsx(Typography, Object.assign({ variant: 'text14', sx: { color: 'greyBlack.main' } }, { children: t('Please be sure — it cannot be recovered!') })) })), _jsxs(DialogActions, Object.assign({ sx: {
                    padding: '0 1.5rem 1.5rem',
                } }, { children: [_jsx(Button, Object.assign({ variant: "text", sx: confirmDialogSGStyles.textButton, onClick: handleDeleteClickClose }, { children: _jsx(Typography, Object.assign({ variant: 'text14', sx: { color: 'greenDark.main' } }, { children: t('Cancel') })) })), _jsx(Button, Object.assign({ variant: "text", sx: confirmDialogSGStyles.textButton, onClick: handleDeleteConfirmClick }, { children: _jsx(Typography, Object.assign({ variant: "text14", sx: { color: 'greenDark.main' } }, { children: t('Delete') })) }))] }))] })));
};
